"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addGoodsMakeMethod = addGoodsMakeMethod;
exports.addGoodsUnit = addGoodsUnit;
exports.deleteById = deleteById;
exports.deleteGoodsMakeMethod = deleteGoodsMakeMethod;
exports.deleteGoodsUnit = deleteGoodsUnit;
exports.downloadImportTemplate = downloadImportTemplate;
exports.downloadNewStoreImageTemplate = downloadNewStoreImageTemplate;
exports.downloadStoreImageTemplate = downloadStoreImageTemplate;
exports.flushedXyGoods = flushedXyGoods;
exports.fullSyncGoods = fullSyncGoods;
exports.getById = getById;
exports.getCategoryTree = getCategoryTree;
exports.getGoodsDetailGroup = getGoodsDetailGroup;
exports.getGoodsEstimateInfo = getGoodsEstimateInfo;
exports.getGoodsMakeMethodInfo = getGoodsMakeMethodInfo;
exports.getMakeMethodTree = getMakeMethodTree;
exports.getUnitList = getUnitList;
exports.insert = insert;
exports.queryList = queryList;
exports.syncGoodsById = syncGoodsById;
exports.syncMakeMethod = syncMakeMethod;
exports.update = update;
exports.updateGoodsMakeMethod = updateGoodsMakeMethod;
exports.updateGoodsMakeMethodType = updateGoodsMakeMethodType;
exports.updateGoodsUnit = updateGoodsUnit;
exports.uploadPhotoAddOrUpd = uploadPhotoAddOrUpd;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
/**
 * 同步做法，隐藏按钮
 * @param data
 * @returns {*}
 */
function syncMakeMethod(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/syncMakeMethod',
    method: 'post',
    data: data
  });
}

// 更新商品制作方法
function updateGoodsMakeMethodType(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/updateGoodsMakeMethodType',
    method: 'post',
    data: data
  });
}

// 下载导入模板
function downloadImportTemplate(type) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/downloadImportTemplate',
    method: 'get',
    params: {
      type: type
    },
    responseType: 'blob'
  });
}

// 获取估清信息
function getGoodsEstimateInfo(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/getGoodsEstimateInfo',
    method: 'post',
    data: data
  });
}

// 同步单个商品数据
function syncGoodsById(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/syncGoodsById',
    method: 'post',
    params: data
  });
}

// 全量同步商品数据
function fullSyncGoods(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/fullSyncGoods',
    method: 'post',
    data: data
  });
}

// 商品列表
function queryList(query) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/page',
    method: 'get',
    params: query
  });
}

// 更新商品制作方法
function updateGoodsMakeMethod(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/updateGoodsMakeMethod',
    method: 'post',
    data: data
  });
}

// 更新商品单位
function deleteGoodsUnit(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/deleteGoodsUnit',
    method: 'post',
    data: data
  });
}

// 更新商品单位
function updateGoodsUnit(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/updateGoodsUnit',
    method: 'post',
    data: data
  });
}

// 添加商品单位
function addGoodsUnit(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/addGoodsUnit',
    method: 'post',
    data: data
  });
}

//获取单位树
function getUnitList() {
  return (0, _requestPIM.default)({
    url: '/xyGoods/unitList',
    method: 'get'
  });
}

//获取品类树
function getCategoryTree() {
  return (0, _requestPIM.default)({
    url: '/xyGoods/getCategoryTree',
    method: 'get'
  });
}
//获取制作方法树
function getMakeMethodTree() {
  return (0, _requestPIM.default)({
    url: '/xyGoods/getMakeMethodTree',
    method: 'get'
  });
}

// 添加关联做法
function addGoodsMakeMethod(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/addGoodsMakeMethod',
    method: 'post',
    data: data
  });
}

// 删除关联做法
function deleteGoodsMakeMethod(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/deleteGoodsMakeMethod',
    method: 'post',
    data: data
  });
}

//获取做法信息
function getGoodsMakeMethodInfo(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/getGoodsMakeMethodInfo',
    method: 'post',
    data: data
  });
}

// 添加商品
function insert(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/saveXyGoods',
    method: 'post',
    data: data
  });
}

// 商品编辑
function update(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/updateXyGoods',
    method: 'post',
    data: data
  });
}

// 删除等级信息
function deleteById(id) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/deleteXyGoods?id=' + id,
    method: 'delete'
  });
}

// 通过id等级信息
function getById(id) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/' + id,
    method: 'get'
  });
}

// 附件上传
function uploadPhotoAddOrUpd(params) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/uploadPhotoAddOrUpd',
    method: 'post',
    data: params
  });
}
function getGoodsDetailGroup(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/getGoodsDetailGroup',
    method: 'post',
    data: data
  });
}
// 刷新缓存单个商品数据
function flushedXyGoods(goodId) {
  return (0, _requestPIM.default)({
    url: '/xyGoods/flushedXyGoods?goodId=' + goodId,
    method: 'get'
  });
}

// 下载门店图片导入模板
function downloadStoreImageTemplate() {
  return (0, _requestPIM.default)({
    url: '/xyGoods/downloadStoreImageTemplate',
    method: 'get',
    responseType: 'blob'
  });
}

// 下载新版门店图片导入模板
function downloadNewStoreImageTemplate() {
  return (0, _requestPIM.default)({
    url: '/xyGoods/downloadNewStoreImageTemplate',
    method: 'get',
    responseType: 'blob'
  });
}